import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Switch, Route, withRouter } from 'react-router'
import _ from 'lodash'
import cx from 'classnames'

import config from '../../config'

import Home from './scenes/Home'

import MainMenu from './components/MainMenu'
import ModuleMenu from './components/ModuleMenu'
import Ribbon from './components/Ribbon'
import EntityStack from './components/EntityStack'
import Workspace from './components/Workspace'
import Tabs from './components/Tabs'

import hocConnect from './hocConnect'

import './style.scss'

const enabledModules = _.reduce(
    config.modules,
    (acc, module) => {
        if (module.enable) return [...acc, module.route]
        return acc
    },
    []
)

const modulesWithRibbon = _.reduce(
    config.modules,
    (acc, module) => {
        if (module.ribbon) return [...acc, module.route]
        return acc
    },
    []
)
const ribbonRegex = new RegExp(`^/(${_.join(modulesWithRibbon, '|')}).*$`)

const modulesWithToolbar = _.reduce(
    config.modules,
    (acc, module) => {
        if (module.toolbar) return [...acc, module.route]
        return acc
    },
    []
)
const toolbarRegex = new RegExp(`^/(${_.join(modulesWithToolbar, '|')}).*$`)

@withRouter
@hocConnect
export default class Gnosus extends Component {
    static propTypes = {
        ribbonOpen: PropTypes.bool.isRequired,
    }

    renderHome = () => (
        <div className={'gnosus__module'}>
            <ModuleMenu hasButton={false} />
            <Home />
        </div>
    )

    renderModule =
        () =>
        ({ match }) => {
            const { ribbonOpen } = this.props

            const hasRibbon = ribbonRegex.test(match.url)
            const hasToolbar = toolbarRegex.test(match.url)

            return (
                <div className={'gnosus__module'}>
                    <ModuleMenu hasButton={hasRibbon} />
                    <Ribbon show={hasRibbon} />
                    <div className={cx('gnosus__content', (!ribbonOpen || !hasRibbon) && 'withoutRibbon')}>
                        <EntityStack hasRibbon={hasRibbon} />
                        <div className={'gnosus__workspace-panel'}>
                            <Workspace hasToolbar={hasToolbar} />
                            <Tabs />
                        </div>
                    </div>
                </div>
            )
        }

    renderRoutes = () =>
        _.map(enabledModules, (moduleRoute) => (
            <Route key={moduleRoute} path={`/${moduleRoute}`} render={this.renderModule(moduleRoute)} />
        ))

    render() {
        return (
            <div className={cx('gnosus', config.iframeSolution && 'iframe')}>
                <MainMenu />
                <Switch>
                    <Route path={'/'} exact render={this.renderHome} />
                    <Route path={`/${config.modules.home.route}`} exact render={this.renderHome} />
                    {this.renderRoutes()}
                </Switch>
            </div>
        )
    }
}
